import { Button, MenuItem, Typography } from '@mui/material';

import { useChainMenuItemStyles } from './useChaiMenuItemStyles';

interface ChainMenuItemProps {
  Icon: React.ElementType<{ className?: string }>;
  children: string;
  onClick: () => void;
}

export const ChainMenuItem = ({
  Icon,
  children,
  onClick,
}: ChainMenuItemProps) => {
  const { classes } = useChainMenuItemStyles();

  return (
    <MenuItem
      className={classes.root}
      component={Button}
      onClick={event => {
        event.stopPropagation();

        onClick();
      }}
      startIcon={<Icon className={classes.icon} />}
      variant="text"
    >
      <Typography variant="body2">{children}</Typography>
    </MenuItem>
  );
};
